import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { LocalStorageService } from './localstorage.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private localStroageService: LocalStorageService,
    private appService: AppService,
  ) {}

  canActivateChild(
    _childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (this.localStroageService.loginToken) return true;
    this.localStroageService.pendingLoginRedirectUrl = state.url;
    this.appService.jumpToLoginAndReplaceUrl();
    return false;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.canActivateChild(route, state);
  }
}
